import ENDPOINTS from 'api/endpoints';
import { doPatch } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { KnowledgeBaseRes, KnowledgeBaseUpdate } from './types';

export const updateKnowledgeBase = ({
  accountId,
  projectId,
  update,
}: {
  accountId: string;
  projectId: string;
  update: KnowledgeBaseUpdate;
}) => {
  return doPatch<KnowledgeBaseRes>(
    generateNextPath(ENDPOINTS.KNOWLEDGE_BASE, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    update,
    { version: 'v2' },
  );
};
